// 财务
export default [
  {
    path: '/finance',
    redirect: '/finance/activate',
  },

  // 组织激活
  {
    path: '/finance/activate',
    name: 'finance-member-activate',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/activate/Index.vue'),
    meta: { title: '会员/企业激活' },
  },
  {
    path: '/finance/activate/active/:id',
    name: 'finance-member-activate-active',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/activate/OrderCreate.vue'),
    meta: { title: '会员/企业激活' },
  },
  {
    path: '/finance/activate/result/:token',
    name: 'finance-member-activate-result',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/activate/OrderResult.vue'),
    meta: { title: '会员/企业激活' },
  },

  // 企业续费，升降级等服务
  {
    path: '/finance/service',
    name: 'finance-member-service',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/service/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/finance/service/renewal/:id',
    name: 'finance-member-renewal',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/service/renewal/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/finance/service/upgrade/:id',
    name: 'finance-member-upgrade',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/service/upgrade/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/finance/service/downgrade/:id',
    name: 'finance-member-downgrade',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/service/downgrade/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/finance/service/terminal/:id',
    name: 'finance-member-terminal',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/service/terminal/Index.vue'),
    meta: { title: '会员/企业管理' },
  },

  // 价格矩阵及操作日志
  {
    path: '/finance/matrix',
    name: 'finance-matrix',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/matrix/Index.vue'),
    meta: { title: '价格服务管理' },
  },
  {
    path: '/finance/logs',
    name: 'finance-logs',
    component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/logs/Index.vue'),
    meta: { title: '财务操作日志' },
  },
];
